import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cns`

    return {
        searchByCns(value) {
            return repository.get(`${baseUrl}/${value}/search-by-cns`)
        },
        searchByCpf(value) {
            return repository.get(`${baseUrl}/${value}/search-by-cpf`)
        },
        searchBy(queryParms) {
            return repository.get(`${baseUrl}/search-by?${urlUtil.serialize(queryParms)}`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
    }
}